import { getAreaAcresFromPolygons, type PolygonRings } from "../../utils/area.js";

/** Undefined when the site has no mapped boundary. */
export const getAreaAcres = (site: { polygons: PolygonRings }): number | undefined =>
    getAreaAcresFromPolygons(site.polygons);
